export const FeatureDisplayNames: Record<string, string> = {
    // Functional groups
    "alkene": "alkene",
    "alkyne": "alkyne",
    "alcohol": "alcohol",
    "ether": "ether",
    "sulfide": "sulfide",
    "thiol": "thiol",
    "isopropyl": "isopropyl",
    "nitro": "nitro",
    "nitrile": "nitrile",

    "amine": "amine",
    "amine.1": "primary amine",
    "amine.2": "secondary amine",
    "amine.3": "tertiary amine",

    // specific alkylHalides
    "alkylHalide": "halide",
    "alkylHalide.flouride": "fluoride",
    "alkylHalide.chloride": "chloride",
    "alkylHalide.bromide": "bromide",
    "alkylHalide.iodide": "iodide",
    "alkylHalide.astatide": "astatide",
    "alkylHalide.tenneside": "tenneside",

    // Carbonyl-like (but not necessarily carbonyls
    "carbonyl": "carbonyl",
    "carbonyl.aldehyde": "aldehyde",
    "carbonyl.ketone": "ketone",
    "carbonyl.carboxylicAcid": "carboxylic acid",
    "carbonyl.ester": "ester",
    "carbonyl.acidAnhydride": "anhydride",

    // Amides come in 3 flabors (primary, secondary and tertiary)
    "carbonyl.amide": "amide",
    "carbonyl.amide.1": "primary amide",
    "carbonyl.amide.2": "secondary amide",
    "carbonyl.amide.3": "tertiary amide",

    "carbonyl.acidHalide.astatide": "acid astatide",
    "carbonyl.acidHalide.bromide": "acid bromide",
    "carbonyl.acidHalide.chloride": "acid chloride",
    "carbonyl.acidHalide.flouride": "acid flouride",
    "carbonyl.acidHalide.iodide": "acid iodide",
    "carbonyl.acidHalide.tennesside": "acid tennesside",
    "carbonyl.acidHalide": "acid halide",

    // Structural
    "ring": "-membered ring",
    "ring.6.cyclohexane": "6-membered ring",
    "ring.6.benzene": "benzene ring",
    "ring.bridge": "-membered bicyclic bridged ring system",
    "ring.3.epoxide": "epoxide",

    // Navigation structural features
    "atomCluster": "-atom cluster",
    "ringSystem": " ring system",
    "ringSystem.naphthalene": "naphthalene",
    "ringSystem.anthracene": "anthracene",

    // Special chains
    "chain": "-carbon chain",
    "chain.1.methyl": "methyl group",
    "chain.2.ethyl": "ethyl group",

    // Loose atoms
    "atom": "atom",
    "chg": "charge",
    "lp": "lonepair",
    "bondedH": "bondedH",

    // Molecules
    "molecule": "molecule",
    "molecule.2.diatomic": "diatomic molecule",

    // Mechanisms
    "protonated": "protonated"

}